import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { maxFileSize } from '../utils/Common';
import { DropzoneType } from '../utils/Types';
import { Box, Grid } from '@mui/material';

function Dropzone(props: DropzoneType) {
    const {
        dropText,
        setBinaryStr,
        accept,
        onError,
        maxFileCount,
    } = props;

    const [ isFileSizeLarger, setIsFileSizeLarger ] = useState(false);

    const onDrop = useCallback((acceptedFiles: any[]) => {
        acceptedFiles.forEach((file: any) => {
            const reader = new FileReader();
      
            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => onError();
            reader.onload = () => {
                const binaryStr = reader.result;
                setBinaryStr(binaryStr, file.path);
            };
            reader.readAsDataURL(file);
        })
    }, [setBinaryStr, onError]);

    const onDropRejected = useCallback((files: any[]) => {
        // console.log(files);
        // console.log(files.length > 0 && files[0].file.size > maxFileSize);
        setIsFileSizeLarger(files.length > 0 && files[0].file.size > maxFileSize);
    }, []);

    const {getRootProps, getInputProps, isDragActive, isDragReject} = useDropzone({maxFiles: maxFileCount ?? 1, maxSize: maxFileSize, accept: accept, onDrop, onDropRejected});
    
    return (
        <Box>
            <Grid item spacing={2} sm={12}>
                <span style={{fontSize: "0.75rem"}}><i>Max ukuran file: {maxFileSize > 1000000 ? `${maxFileSize / (1024 * 1024)} MB` : `${maxFileSize / 1024} KB`}</i></span>
            </Grid>
            <Grid
                {...getRootProps()}
                item
                spacing={2}
                sm={12}
                sx={{
                    display: "flex",
                    padding: "1rem",
                    alignItems: "center",
                    justifyContent: "center",
                    borderStyle: "solid",
                    borderWidth: "0.125rem",
                    borderColor: "#dcdcdc",
                    borderRadius: "0.5rem",
                }}
            >
                <input {...getInputProps()} className="w-100 h-100" />
                {
                    !isFileSizeLarger && isDragActive && !isDragReject ?
                    <span className="w-100 text-center"><i>Letakkan file di sini.</i></span>
                    :
                    (
                        !isFileSizeLarger && !isDragActive && !isDragReject ?
                        <span className="w-100 text-center"><i>
                        {
                            dropText ?? "Letakkan file di sini, atau klik dan pilih file yang ingin diunggah."
                        }
                        </i></span>
                        :
                        null
                    )
                }
                {
                    !isFileSizeLarger && isDragReject ?
                    <span className="w-100 text-center"><i>Tipe file tidak sesuai.</i></span>
                    :
                    null
                }
                {
                    isFileSizeLarger ?
                    <span className="w-100 text-center"><i>Ukuran file terlalu besar.</i></span>
                    :
                    null
                }
            </Grid>
        </Box>
    );
}

Dropzone.defaultProps = {
    maxFileCount: 1
}

export default Dropzone;
